webpackJsonp([35783957827783],{

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Skillbar = function Skillbar(_ref) {
	    var title = _ref.title,
	        percentage = _ref.percentage;
	    return _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	            "h4",
	            null,
	            title
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "progress" },
	            _react2.default.createElement("div", { className: "percentage", style: { width: percentage + "%" } })
	        )
	    );
	};
	
	exports.default = Skillbar;
	module.exports = exports["default"];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PageHeader = __webpack_require__(56);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Page = __webpack_require__(54);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _PageBody = __webpack_require__(55);
	
	var _PageBody2 = _interopRequireDefault(_PageBody);
	
	var _Skillbar = __webpack_require__(209);
	
	var _Skillbar2 = _interopRequireDefault(_Skillbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	    return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_PageHeader2.default, { title: 'About' }),
	        _react2.default.createElement(
	            _PageBody2.default,
	            null,
	            _react2.default.createElement(
	                'div',
	                { id: 'main', className: 'site-main' },
	                _react2.default.createElement(
	                    'article',
	                    { className: 'page type-page status-publish hentry' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'entry-content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'vc_row wpb_row vc_row-fluid vc_custom_1522307314558 vc_row-has-fill' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'wpb_column vc_column_container vc_col-sm-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'vc_column-inner ' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'wpb_wrapper' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'cms-about-wrap info-about' },
	                                            _react2.default.createElement(
	                                                'ul',
	                                                { className: 'info-list' },
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    'Name: ',
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        null,
	                                                        'Gabriel M\xE9rida'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    'Based on: ',
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        null,
	                                                        'Melbourne, AU'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    'Email: ',
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: 'mailto:contacto@gabrielmerida.cl' },
	                                                            'contacto@gabrielmerida.cl'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'vc_row wpb_row vc_row-fluid vc_custom_1522307320266' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'wpb_column vc_column_container vc_col-sm-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'vc_column-inner ' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'wpb_wrapper' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        { style: { textAlign: 'left' }, className: 'vc_custom_heading vc_custom_1522135929357' },
	                                        'Full stack web developer'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'wpb_text_column wpb_content_element  vc_custom_1522136306311' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'wpb_wrapper' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                'Experienced in PHP, Javascript ES2015, front-end development and frameworks like Laravel and ReactJS.'
	                                            ),
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                'I have developed websites for over 10 years, from corporate websites to data visualization mash-ups.'
	                                            ),
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                'With a background in UX design, Information Architecture and Web Project Management.'
	                                            ),
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                'I consider my stronger skills to be proactive, solution-driven, fast and eager learner.'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'vc_row wpb_row vc_row-fluid gray-bg vc_custom_1522307330161' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'wpb_column vc_column_container vc_col-sm-6' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'vc_column-inner ' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'wpb_wrapper' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'cms-skill-wrap my-skill' },
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: 'list-skill' },
	                                            _react2.default.createElement(_Skillbar2.default, { title: 'ReactJS', percentage: 85 }),
	                                            _react2.default.createElement(_Skillbar2.default, { title: 'ES2015', percentage: '80' }),
	                                            _react2.default.createElement(_Skillbar2.default, { title: 'Flow', percentage: '75' }),
	                                            _react2.default.createElement(_Skillbar2.default, { title: 'GraphQL / Apollo', percentage: '65' })
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'wpb_column vc_column_container vc_col-sm-6' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'vc_column-inner ' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'wpb_wrapper' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'cms-skill-wrap my-skill' },
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: 'list-skill' },
	                                            _react2.default.createElement(_Skillbar2.default, { title: 'PHP OOP 5.6 > 7.x', percentage: '75' }),
	                                            _react2.default.createElement(_Skillbar2.default, { title: 'Laravel 5.x', percentage: '85' }),
	                                            _react2.default.createElement(_Skillbar2.default, { title: 'WordPress', percentage: '90' }),
	                                            _react2.default.createElement(_Skillbar2.default, { title: 'AWS', percentage: '35' }),
	                                            _react2.default.createElement(_Skillbar2.default, { title: 'Elasticsearch', percentage: '30' })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-401ecbf5e27465a3a0e1.js